import { Dimensions, NativeModules, Platform } from 'react-native';

const usesNativeDimensions = () => NativeModules.MacMenuBridge?.nativeWindowDimensions === true;

// Older binaries need the root-layout fallback below. Current binaries publish
// content-area dimensions natively; replaying an older onLayout during zoom
// would make responsive controls jump back before reaching the new size.

let rootLayout = null;

function syncRootDimensions() {
  if (!rootLayout) return;
  const { width, height } = rootLayout;
  const current = Dimensions.get('window');
  if (Math.abs(current.width - width) < 0.5 && Math.abs(current.height - height) < 0.5) return;
  Dimensions.set({ window: { ...current, width, height }, screen: Dimensions.get('screen') });
}

// AppKit focus/modal transitions can publish the display's size as the window
// size even when the root view hasn't resized. Correct those events after all
// listeners have received them, so useWindowDimensions cannot retain the stale
// event after a nested synchronous correction. One observer lives at the root.
export function maintainMacWindowDimensions() {
  if (Platform.OS !== 'macos' || usesNativeDimensions()) return undefined;
  let active = true;
  let scheduled = false;
  const subscription = Dimensions.addEventListener('change', () => {
    if (scheduled || !rootLayout) return;
    scheduled = true;
    Promise.resolve().then(() => {
      scheduled = false;
      if (active) syncRootDimensions();
    });
  });
  return () => {
    active = false;
    subscription.remove();
  };
}

// macOS can initialize DeviceInfo before the application has a key window,
// leaving its window-size observer detached. Use the actual root layout so
// responsive controls also update during native window tiling and resizing.
export function updateMacWindowDimensions(event) {
  if (Platform.OS !== 'macos' || usesNativeDimensions()) return;
  const { width, height } = event?.nativeEvent?.layout || {};
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return;
  rootLayout = { width, height };
  syncRootDimensions();
}
